import { jsx as _jsx } from "react/jsx-runtime";
import { Cards, CardsPDF } from '@monorepo-web/components-library';
import { FormatTypes, helperFormat } from '@monorepo-web/utils';
import { layouts } from './layouts';
export default function CardsResumoCarteira({ info, moneyPrefix, replaceLabelCards, layout = 'default', dispatchPDF = false }) {
    var _a, _b;
    const config = layouts[layout];
    let cardsFormated = null;
    const cards = {
        "saldo1": {
            title: `${(_a = replaceLabelCards === null || replaceLabelCards === void 0 ? void 0 : replaceLabelCards.saldo1) !== null && _a !== void 0 ? _a : 'Saldo'} ${info === null || info === void 0 ? void 0 : info.datas.data_ini.split('-').reverse().join('/')}`,
            value: helperFormat(info === null || info === void 0 ? void 0 : info.saldoIni, FormatTypes.monetary, 2, moneyPrefix),
        },
        "movim": {
            title: 'Movimentações',
            value: helperFormat(info === null || info === void 0 ? void 0 : info.movimentacoes, FormatTypes.monetary, 2, moneyPrefix),
        },
        "impostosPagos": {
            title: 'Impostos Pagos',
            value: helperFormat(info === null || info === void 0 ? void 0 : info.impostospagos, FormatTypes.monetary, 2, moneyPrefix),
        },
        "rendimentoBruto": {
            title: 'Rendimento Bruto',
            value: helperFormat(info === null || info === void 0 ? void 0 : info.rendimentoBruto, FormatTypes.monetary, 2, moneyPrefix),
        },
        "saldo2": {
            title: `${(_b = replaceLabelCards === null || replaceLabelCards === void 0 ? void 0 : replaceLabelCards.saldo2) !== null && _b !== void 0 ? _b : 'Saldo'} ${info === null || info === void 0 ? void 0 : info.datas.data_fim.split('-').reverse().join('/')}`,
            value: helperFormat(info === null || info === void 0 ? void 0 : info.saldoFim, FormatTypes.monetary, 2, moneyPrefix),
        }
    };
    cardsFormated = info ? config.map(key => cards[key]) : null;
    return dispatchPDF ?
        _jsx(CardsPDF, { cards: cardsFormated }) : _jsx(Cards, { cards: cardsFormated });
}
